module.exports = __webpack_public_path__ + "img/icon-differentials2_07.db253ea5.svg";